import lazyLoadView from "@router/lazyload-view";
import routeError from "./route-error";
import routeNews from "@/src/router/route-news";
import routeAbout from "@/src/router/route-about";
import routeSolution from "@/src/router/route-solution";
import routeResource from "@/src/router/route-resource";
import store from '@src/store'

export default [
  ...routeNews,
  ...routeAbout,
  ...routeSolution,
  ...routeResource,
  // 404
  {
    path: '/product/brand/microsoft/solutionhub/404',
    name: '404',
    component: require('@views/_404').default,
    meta: {
      showBreadcrumb: false,
    },
    props: true,
  },
  // 首頁
  {
    path: '/product/brand/microsoft/solutionhub',
    name: 'home',
    component: () => lazyLoadView(import('@views/Home/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [items, solutionOption, solutionList] = await Promise.all([
            store.dispatch('global/fetchHome'),
            store.dispatch('option/fetchOptionList', {
              types: 'solution',
              useCached: true
            }),
            store.dispatch('article/fetchList', {
              contentAlias: 'solution',
              params: {
                limit: 6,
                page: 1,
              }
            })
          ])
          routeTo.params.solutionOption = solutionOption
          routeTo.params.module = items
          routeTo.params.solutionList = solutionList.items
          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
    },
    props: (route) => ({
      module: route.params.module,
      solutionOption: route.params.solutionOption,
      solutionList: route.params.solutionList
    }),
  },
  {
    path: '/product/brand/microsoft/solutionhub/search/:tag',
    name: 'search',
    component: () => lazyLoadView(import('@views/Search/Index')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch(error) {
          routeError(error, routeTo, next({ name: '404' }));
        }
      },
      title: '標籤搜尋'
    },
    props: (route) => ({

    }),
  },
  // Style Guide
  {
    path: '/product/brand/microsoft/solutionhub/style-guide',
    name: 'style-guide',
    component: () => lazyLoadView(import('@views/StyleGuide/Index')),
  },
  {
    path: '*',
    redirect: '/product/brand/microsoft/solutionhub/404',
  },
]
